module.exports = __webpack_public_path__ + "img/functionIntroduction.c81365b3.jpg";